import { Navigate } from 'react-router-dom';
// hooks
import { useSelector } from '../redux/store';
// config
import { PATH_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

type TenantOrganizationGuardProps = {
  children: React.ReactNode;
};

/**
 * Guard that only allows access when tenantVenue is an organization (string, not a venue object).
 * If tenant is a specific venue, redirects to dashboard app.
 */
export default function TenantOrganizationGuard({ children }: TenantOrganizationGuardProps) {
  const { tenantVenue } = useSelector((state) => state.venue);

  // Check if tenantVenue is a venue object (not organization)
  const isVenueSelected = typeof tenantVenue === 'object' && tenantVenue !== null;

  // If a specific venue is selected, redirect to dashboard app
  if (isVenueSelected) {
    return <Navigate to={PATH_DASHBOARD.general.app} replace />;
  }

  // Allow access if tenantVenue is organization_id (string) or 'all'
  return <>{children}</>;
}

